class ConsentProvider {
    constructor() {
        if (this.constructor === ConsentProvider) {
            throw new Error("Abstract classes can't be instantiated.");
        }
    }
    getAllowTracking() {
        throw new Error("Method 'allowTracking()' must be implemented.");
    }
    handleConsentPush() {
        throw new Error("Method 'handleConsent()' must be implemented.");
    }
    // Reopen the provider's own consent/privacy settings UI. Returns true if
    // handled, false if this provider has no JS-openable settings
    openSettings() {
        return false;
    }
}
export default ConsentProvider;
